import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function FalcoExhibition() {
  const dateTexts = ['1901年'];
  const title = 'カメリアファルコ生誕100周年を記念した特別展開催';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2021/12/DSC01463.jpg'
  const description = (
    <>
      <a href='/camellia-falco'>
        {'カメリアファルコ'}
      </a>
      {'生誕100周年を記念した特別展がファンタスティック・フライトミュージアムで開催され、そこに訪れたゲストがカメリアのスピリットに遭遇する。'}
    </>
  );


  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
    />
  );
}

export default FalcoExhibition;
